import { queryOptions } from '@tanstack/react-query'

import { fetchWarmupWeekdayCompletion } from '../dal/warmup-dal'
import { queryKeys } from './query-keys'

export const warmupWeekdayCompletionQueryOptions = (yearWeek: string) =>
  queryOptions({
    queryKey: queryKeys.warmup.weekdayCompletion(yearWeek),
    queryFn: () => fetchWarmupWeekdayCompletion(yearWeek),
    staleTime: 60 * 1000,
  })
